export default __webpack_public_path__ + "static/amerex_mex_logo_neg-d627bb546ccb7a436497c28e335e081c.svg";